import { ConstantRoutes } from "../../../core/constantRoutes";
import AdminUploadConfigMain from "../adminUploadConfigMain/adminUploadConfigMain";

function AdminEcus() {
    return(<>
        <AdminUploadConfigMain type="ecus" fileName="Ecus.json" 
              label="Ecus" path={ConstantRoutes.adminEcus}/>
    </>)
}

export default AdminEcus;